<template>
    <div class="page magic-bg dark:text-white">
        <navigation :key="navigationKey"/>

        <div class="bookmark">
            <div class="bookmark-container">
                <div class="bookmark-modal" id="tickets_adjustments">
                    <div class="flex flex-row items-center justify-between mb-2">
                        <p class="bookmark-modal-title text-gradient mr-auto">Сортировка</p>
                        <button class="rounded-button" title="Очистить сортировку" @click="ClearParams">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 hover:animate-spin" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Поиск</label>
                        <input class="input sm:ml-2" type="text" v-model="search_param">
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Только актуальные</label>
                        <input class="checkbox-toggle sm:ml-auto" type="checkbox" v-model="is_relevant">
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Статус</label>
                        <select class="input sm:ml-2" v-model="status">
                            <option value="">Все</option>
                            <option value="opened">Открытые</option>
                            <option value="closed">Закрытые</option>
                        </select>
                    </div>
                    <p class="bookmark-modal-title text-gradient mr-auto">Инструменты</p>
                    <button class="mt-2 ml-2 mr-auto" @click="pageNumber = 0;GetTickets()">Запросить данные заново</button>
                </div>
            </div>
            <div class="bookmark-navbar">
                <div class="bookmark-link" @click="$root.ToggleBookmark('#tickets_adjustments')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                    </svg>
                </div>
            </div>
        </div>

        <div class="flex flex-row items-end justify-between mt-4 w-[90%] max-w-7xl mx-auto fade">
            <div class="flex flex-row items-center justify-center background rounded-t-lg ml-3 py-2 px-3 fade">
                <p>С</p>
                <p class="ml-2">{{pageNumber * elementNumber + 1}}</p>
                <p class="ml-2">по</p>
                <p class="ml-2">{{pageNumber * elementNumber + renderTickets.length}}</p>
                <p class="ml-2"><b class="text-gradient">Всего:</b> {{ticketCount}}</p>
            </div>
            <div class="flex flex-row items-center justify-center background rounded-t-lg mr-3 py-2 px-3 fade">
                <button @click="Back">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
                <p>{{pageNumber + 1}}</p>
                <p class="ml-2">из</p>
                <p class="ml-2">{{pagesCount}}</p>
                <button @click="Forward">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>

        <div class="card py-0 w-[90%] max-w-7xl mx-auto overflow-auto fade" style="max-height: calc(100vh - 10rem)">
            <table class="sys-table mb-2">
                <thead>
                    <th>№</th>
                    <th v-if="$root.HasRole($store.state.adminRole)">ID</th>
                    <th>Название</th>
                    <th>Отправитель</th>
                    <th>Источник</th>
                    <th>Дата создания</th>
                    <th>Дата завершения</th>
                    <th>Темы</th>
                    <th>Статус</th>
                    <th></th>
                </thead>
                <tbody>
                    <tr v-for="(ticket, index) in renderTickets" :key="ticket.id">
                        <th>{{pageNumber * elementNumber + index + 1}}</th>
                        <td class="text-center" v-if="$root.HasRole($store.state.adminRole)">{{ticket.id}}</td>
                        <td class="text-center">{{ticket.title}}</td>
                        <td class="text-center" :data-id="ticket.creator">{{users[ticket.creator] || "Неизвестно"}}</td>
                        <td class="text-center">{{ ticket.source ?? "Неизвестно" }}</td>
                        <td class="text-center">{{new Date(ticket.time_created).toLocaleString("ru-RU", {day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "numeric"})}}</td>
                        <td class="text-center" v-if="ticket.is_closed">{{new Date(ticket.time_closed).toLocaleString("ru-RU", {day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "numeric"})}}</td>
                        <th v-else>-</th>
                        <th><div class="block text-gradient text-sm my-2" v-for="(theme) in ticket.themes" :key="theme">{{ThemeByID(theme) !== null ? ThemeByID(theme).title : ''}}</div></th>
                        <th><div class="badge danger my-2" v-if="ticket.is_closed">Закрыт</div><div class="badge success my-2" v-else>Открыт</div></th>
                        <th>
                            <button class="text-info hover:animate-pulse" @click="OpenChat(ticket.id)">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
                                    <path fill-rule="evenodd" d="M2 10c0-3.967 3.69-7 8-7 4.31 0 8 3.033 8 7s-3.69 7-8 7a9.165 9.165 0 01-1.504-.123 5.976 5.976 0 01-3.935 1.107.75.75 0 01-.584-1.143 3.478 3.478 0 00.522-1.756C2.979 13.825 2 12.025 2 10z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation'

export default {
    components: {
        Navigation
    },
    data() {
        return {
            socket: null,
            navigationKey: "nav",
            title: "Список тикетов",
            tickets: {},
            renderTickets: [],
            themes: [],
            users: {},
            elementNumber: 15,
            pageNumber: 0,
            ticketCount: 0,
            pagesCount: 0,
            search_param: "",
            is_relevant: true,
            status: "",
        }
    },
    methods: {
        SetTitle() {
            document.title = `Samgk Служба заботы - ${this.title}`
        },
        Forward() {
            this.pageNumber = this.pageNumber >= this.pagesCount - 1 ? 0 : this.pageNumber + 1
            this.UpdateRenderTickets()
        },
        Back() {
            this.pageNumber = this.pageNumber <= 0 ? this.pagesCount - 1 : this.pageNumber - 1
            this.UpdateRenderTickets()
        },
        ClearParams() {
            this.search_param = ""
            this.is_relevant = true
            this.status = ""
        },
        ThemeByID(id) {
            for (var i in this.themes) {
                var theme = this.themes[i]

                if (theme.id == id)
                    return this.$root.CopyData(theme)
            }

            return null
        },
        UpdateRenderTickets() {
            let rawResult = Object.entries(this.tickets).map(([id, data]) => {
                let resultData = null
                if (this.search_param !== "") {
                    let search_param = this.search_param.toLowerCase()
                    let splittedSearch = search_param.split(",")

                    splittedSearch.forEach((value, index, array) => array[index] = value.replace(/\s{2,}/g, ' ').trim())

                    this.validate = function(item) {
                        let includesTheme = false
                        for (var i in data.themes) {
                            for (var j in this.themes) {
                                var theme = this.themes[j]
                                if (theme.id === data.themes[i]) {
                                    if (theme.title.toLowerCase().includes(item)) includesTheme = true
                                    break
                                }
                            }
                        }

                        if (data.title.toLowerCase().includes(item) 
                            || (data.creator in this.users && this.users[data.creator].toLowerCase().includes(item))
                            || includesTheme
                        )
                        return true

                        return false
                    }

                    for (var i in splittedSearch) {
                        var item = splittedSearch[i]

                        if (this.validate(item)) {
                            resultData = data
                            break
                        }
                    }
                } else {
                    resultData = data
                }

                if (resultData !== null) {
                    switch (this.status) {
                        case "opened":
                            if (resultData.is_closed) resultData = null
                            break;
                        case "closed":
                            if (!resultData.is_closed) resultData = null
                            break;
                    }
                }

                return resultData
            }).filter(item => item !== null)
            let result = rawResult.slice(this.pageNumber * this.elementNumber, this.pageNumber * this.elementNumber + this.elementNumber)

            this.ticketCount = rawResult.length

            this.pagesCount = Math.ceil(this.ticketCount / this.elementNumber)

            result.sort((a, b) => {
                return new Date(b.time_created) - new Date(a.time_created)
            })

            this.renderTickets = result
        },
        async GetTickets() {
            let res = await fetch(this.$store.state.supportApiAddr + `/v1.0/tickets/me/list/v2?actual=${this.is_relevant}`, {
                method: "GET",
                headers: {
                    'Content-Type': 'text/json;charset=utf-8',
                    'Authorization': `Bearer ${this.$root.GetToken()}`
                },
                credentials: 'include'
            })
            .then(response => response.json())

            this.tickets = res.data.tickets
            this.ticketCount = Object.keys(res.data.tickets).length

            this.users = res.data.users
            this.pagesCount = Math.ceil(this.ticketCount / this.elementNumber)

            this.UpdateRenderTickets()
        },
        async GetThemes() {
            let res = await fetch(this.$store.state.supportApiAddr + "/v1.0/themes/all", {
                method: "GET",
                headers: {
                    'Content-Type': 'text/json;charset=utf-8',
                    'Authorization': `Bearer ${this.$root.GetToken()}`
                },
                credentials: 'include'
            })
            .then(response => response.json())

            this.themes = res.data.themes
        },
        OpenChat(id) {
            this.$store.commit("setChatLink", {id: this.tickets[id].id, status: this.tickets[id].is_closed ? this.$store.state.chatStatus.F : this.$store.state.chatStatus.A })
            this.$router.push({name: "UserChat"})
        },
        AddTheme(theme) {
            this.themes.push(theme)
        },
        UpdateTheme(theme) {
            this.themes[this.themes.map((value) => value.id).indexOf(theme.id)] = theme
        },
        RemoveTheme(theme) {
            this.themes.splice(this.themes.map((value) => value.id).indexOf(theme), 1)
        },
        AddTicket(ticket) {
            this.tickets[ticket.id] = ticket
            this.ticketCount = Object.keys(this.tickets).length
        },
        UpdateTicket(ticket) {
            this.tickets[this.tickets.map((value) => value.id).indexOf(ticket.id)] = ticket
        },
        async StartWebsocket() {
            if (this.$route.name !== "Home" || this.socket !== null || !this.$root.IsServiceEnabled()) return

            let socket = new WebSocket(this.$store.state.wsAddr + "/v1.0/ws")

            let ShowToast = this.$root.ShowToast
            let token = this.$root.GetWSAuthData()

            let AddTheme = this.AddTheme
            let UpdateTheme = this.UpdateTheme
            let RemoveTheme = this.RemoveTheme
            let AddTicket = this.AddTicket
            let UpdateTicket = this.UpdateTicket

            socket.onopen = () => {
                socket.send(token)
            }

            socket.onmessage = function(event) {
                let data = JSON.parse(event.data)

                switch (data.type) {
                    case "new_ticket":
                        AddTicket(data.data)
                        break;
                    case "closed_ticket":
                        UpdateTicket(data.data)
                        break;
                    case "new_theme":
                        AddTheme(data.data)
                        break;
                    case "updated_theme":
                        UpdateTheme(data.data)
                        break;
                    case "removed_theme":
                        RemoveTheme(data.data)
                        break;
                }
            }

            socket.onclose = () => {setTimeout(() => {this.StartWebsocket()}, 10000)}

            socket.onerror = function(event) {
                ShowToast("Не удалось установить соединение с сервером. Подгрузка данных в реальном времени невозможна", "warning")
            }

            this.socket = socket
        },
    },
    watch: {
        search_param(value) {
            this.search_param = value.replace(/\s{2,}/g, ' ')
            this.UpdateRenderTickets()
            this.pageNumber = 0
        },
        status() {
            this.UpdateRenderTickets()
            this.pageNumber = 0
        },
        is_relevant() {
            this.GetTickets()
            this.pageNumber = 0
        }
    },
    beforeUnmount() {
        if (this.socket !== null) this.socket.close()
    },
    mounted() {
        if (this.$root.fatal) return
        this.SetTitle()

        this.$root.StartLoading()
        this.$root.UpdateToken()
        this.$root.GetRoles().then(()=>{
            if (!(this.$root.HasRole(this.$store.state.operatorRole) || this.$root.HasRole(this.$store.state.mainOperatorRole) || this.$root.HasRole(this.$store.state.adminRole))) {
                this.$root.ShowToast("Отказано в доступе", "error")
                this.$router.push({name: 'Logout'})
            }

            setTimeout(() => {
                this.GetThemes()
                this.GetTickets().then(()=> {
                    this.$root.EndLoading()
                })
                setTimeout(()=> {
                    this.$root.StartWebsocket()
                    this.StartWebsocket()
                }, 100)
            }, 300)
        })
    }
}
</script>